module.exports = __webpack_public_path__ + "assets/img/17_937.a088b566.jpg";